<div class="wrapper bg-area" *ngIf="!isMobile">
  <section id="seguranca">
    <div class="container area-faca-parte">
      <div class="header-faca-parte columns">
        <div class="column is-6">
          <h3 class="title">Monte seu Plano</h3>
          <div class="bar__container">
            <ul class="bar" id="bar">
              <li class="active active-step"><i class="fas fa-check"></i>Plano</li>
              <li class="active active-step"><i class="fas fa-check"></i>Dados Pessoais</li>
              <li class="active active-step"><i class="fas fa-check"></i>Pagamento</li>
              <li class="active">Segurança</li>
              <li>Confirmação</li>
            </ul>
          </div>
        </div>
      </div>
      <form>
        <div class="body-faca-parte columns">
          <div class="column is-6">

            <div class="dados-pessoais">

              <h4>Estamos quase lá</h4>
              <p>Por Segurança, só preciso de mais essas informações para Finalizar o seu Cadastro!</p>

              <p class="opcao-cobranca"><strong>QUAL O SEU VÍNCULO EMPREGATÍCIO?</strong></p>

              <div class="radio-selector">
                <label class="radio-input" for="tOS">
                  <input type="radio" checked="checked" name="vinculo-empregaticio" id="tOS" [value]="'S'" [(ngModel)]="tipoOcupacao">
                  <span class="checkmark">Funcionário Público</span>
                </label>

                <label class="radio-input" for="tOAP">
                  <input type="radio" name="vinculo-empregaticio" id="tOAP" [value]="'P'" [(ngModel)]="tipoOcupacao">
                  <span class="checkmark">Aposentado</span>
                </label>

                <label class="radio-input" for="tOP">
                  <input type="radio" name="vinculo-empregaticio" id="tOP" [value]="'P1'" [(ngModel)]="tipoOcupacao">
                  <span class="checkmark">Pensionista</span>
                </label>

                <label class="radio-input" for="tOC">
                  <input type="radio" name="vinculo-empregaticio" id="tOC" [value]="'C'" [(ngModel)]="tipoOcupacao">
                  <span class="checkmark">Funcionário Privado</span>
                </label>

                <label class="radio-input" for="tOA">
                  <input type="radio" name="vinculo-empregaticio" id="tOA" [value]="'A'" [(ngModel)]="tipoOcupacao">
                  <span class="checkmark">Autônomo</span>
                </label>

                <label class="radio-input" for="tOE">
                  <input type="radio" name="vinculo-empregaticio" id="tOE" [value]="'E'" [(ngModel)]="tipoOcupacao">
                  <span class="checkmark">Empresário</span>
                </label>
              </div>

              <p class="opcao-cobranca"><strong>QUAL A SUA RENDA MENSAL?</strong></p>


              <div class="radio-selector">
                <label class="radio-input">
                  <input type="radio" [value]="11" checked="checked" name="renda-mensal" [(ngModel)]="renda">
                  <span class="checkmark">De R$ 1.500,01 a R$ 2.500,00</span>
                </label>

                <label class="radio-input">
                  <input type="radio" [value]="12" name="renda-mensal" [(ngModel)]="renda">
                  <span class="checkmark">De R$ 2.500,01 a R$ 3.500,00</span>
                </label>

                <label class="radio-input">
                  <input type="radio" [value]="13" name="renda-mensal" [(ngModel)]="renda">
                  <span class="checkmark">De R$ 3.500,01 a R$ 5.000,00</span>
                </label>

                <label class="radio-input">
                  <input type="radio" [value]="14" name="renda-mensal" [(ngModel)]="renda">
                  <span class="checkmark">De R$ 5.000,01 a R$ 10.000,00</span>
                </label>

                <label class="radio-input">
                  <input type="radio" [value]="15" name="renda-mensal" [(ngModel)]="renda">
                  <span class="checkmark">De R$ 10.000,01 a R$ 20.000,00</span>
                </label>

                <label class="radio-input">
                  <input type="radio" [value]="16" name="renda-mensal" [(ngModel)]="renda">
                  <span class="checkmark">Acima de 20.000,00</span>
                </label>
              </div>

            </div>
          </div>

          <app-resumo [result]="propostaResult" [totalDiarias]="countDiarias">
            <button type="button" (click)="goToConfirmacao()" class="btn-verde">FINALIZAR CADASTRO</button>
          </app-resumo>
        </div>
      </form>
    </div>
  </section>

  <div class="aviso">
    <div class="revise-dados">
      <h3>Olá, Pedro!</h3>
      <a href="" class="link-verde">Não sou o Pedro</a>
      <p>Identificamos pelo seu CPF que você já é um cliente Montreal. Para agilizar sua compra, revise os dadoes e
        confirme efetuando seu login.</p>

      <a href="" class="btn-verde">REVISAR E CONCLUIR</a>
      <a href="" class="link-verde">Preciso atualizar meu cadastro</a>
    </div>
  </div>

</div>
<div class="wrapper bg-area" *ngIf="isMobile">
  <section id="seguranca-mobile">
    <div class="container area-faca-parte">
      <div class="header-faca-parte columns">
        <div class="column is-6">
          <div class="title">
            <h3>Estamos quase lá</h3>
          </div>
          <div class="subtitle">
            <h4>Por Segurança, só preciso de mais essas informações para Finalizar o seu Cadastro!</h4>
          </div>
          <div class="dados-pessoais">
            <div class="vinculo-empregaticio">
              <p class="opcao-cobranca"><strong>QUAL O SEU VÍNCULO EMPREGATÍCIO?</strong></p>
              <div class="radio-selector">
                <label class="radio-input" for="tOS_mobile">
                  <input type="radio"
                         checked="checked"
                         name="vinculo-empregaticio"
                         id="tOS_mobile"
                         [value]="'S'"
                         [(ngModel)]="tipoOcupacao">
                  <span class="checkmark">Funcionário Público</span>
                </label>
                <label class="radio-input" for="tOAP_mobile">
                  <input type="radio"
                         name="vinculo-empregaticio"
                         id="tOAP_mobile"
                         [value]="'P'"
                         [(ngModel)]="tipoOcupacao">
                  <span class="checkmark">Aposentado</span>
                </label>
                <label class="radio-input" for="tOP_mobile">
                  <input type="radio"
                         name="vinculo-empregaticio"
                         id="tOP_mobile"
                         [value]="'P1'"
                         [(ngModel)]="tipoOcupacao">
                  <span class="checkmark">Pensionista</span>
                </label>
                <label class="radio-input" for="tOC_mobile">
                  <input type="radio"
                         name="vinculo-empregaticio"
                         id="tOC_mobile"
                         [value]="'C'"
                         [(ngModel)]="tipoOcupacao">
                  <span class="checkmark">Funcionário Privado</span>
                </label>
                <label class="radio-input" for="tOA_mobile">
                  <input type="radio"
                         name="vinculo-empregaticio"
                         id="tOA_mobile"
                         [value]="'A'"
                         [(ngModel)]="tipoOcupacao">
                  <span class="checkmark">Autônomo</span>
                </label>
                <label class="radio-input" for="tOE_mobile">
                  <input type="radio"
                         name="vinculo-empregaticio"
                         id="tOE_mobile"
                         [value]="'E'"
                         [(ngModel)]="tipoOcupacao">
                  <span class="checkmark">Empresário</span>
                </label>
              </div>
            </div>
            <div class="renda-mensal">
              <p class="opcao-cobranca"><strong>QUAL A SUA RENDA MENSAL?</strong></p>
              <div class="radio-selector">
                <label class="radio-input">
                  <input type="radio" [value]="11" checked="checked" name="renda-mensal" [(ngModel)]="renda">
                  <span class="checkmark">De R$ 1.500,01 a R$ 2.500,00</span>
                </label>
                <label class="radio-input">
                  <input type="radio" [value]="12" name="renda-mensal" [(ngModel)]="renda">
                  <span class="checkmark">De R$ 2.500,01 a R$ 3.500,00</span>
                </label>
                <label class="radio-input">
                  <input type="radio" [value]="13" name="renda-mensal" [(ngModel)]="renda">
                  <span class="checkmark">De R$ 3.500,01 a R$ 5.000,00</span>
                </label>
                <label class="radio-input">
                  <input type="radio" [value]="14" name="renda-mensal" [(ngModel)]="renda">
                  <span class="checkmark">De R$ 5.000,01 a R$ 10.000,00</span>
                </label>
                <label class="radio-input">
                  <input type="radio" [value]="15" name="renda-mensal" [(ngModel)]="renda">
                  <span class="checkmark">De R$ 10.000,01 a R$ 20.000,00</span>
                </label>
                <label class="radio-input">
                  <input type="radio" [value]="16" name="renda-mensal" [(ngModel)]="renda">
                  <span class="checkmark">Acima de 20.000,00</span>
                </label>
              </div>
            </div>
            <form>
              <div class="column is-6 resumo-compra" *ngIf="propostaResult">
                <div class="area-fixed-resumo" *ngIf="isMobile">
                  <div class="seu-plano">
                    <div class="total">
                      <div *ngIf="isCupomValido != null && isCupomValido && cupom">
                        <h4>
                          <strong>Taxa de adesão</strong>
                        </h4>
                        <p class="valores-cupom">
                          <span>De</span>
                          <span class="line-through">
                        {{propostaResult ? propostaResult.valorAdesao.toString() : '0'}}
                        </span>
                        </p>
                        <p class="valores-cupom vc2">
                          <small>Por</small>
                          <span class="valor-final"> {{propostaResult ? propostaResult.valorAdesaoDesconto.toString() : '0'}}</span>
                        </p>
                      </div>

                      <div *ngIf="!isCupomValido">
                        <h4>
                          <strong>Taxa de adesão</strong>
                        </h4>
                        <p class="valores-cupom">
                          <span></span>
                          <span class="line-through"></span>
                        </p>
                        <p class="valores-cupom vc2">
                          <small></small>
                          <span class="valor-final"> {{propostaResult.valorAdesao.toString()}}</span>
                        </p>
                      </div>

<!--                      <div *ngIf="isCupomValido != null && isCupomValido && cupom">-->
<!--                        <h4>-->
<!--                          <strong>Mensalidade</strong>-->
<!--                        </h4>-->
<!--                        <p  class="valores-cupom">-->
<!--                          <span>De</span>-->
<!--                          <span class="line-through">-->
<!--                        {{propostaResult && propostaResult.valorMensalidade? propostaResult.valorMensalidade.toString() : '0'}}-->
<!--                        </span>-->
<!--                        </p>-->
<!--                        <p  class="valores-cupom mvc2">-->
<!--                          <small>Por</small>-->
<!--                          <span class="valor-final">-->
<!--                        {{propostaResult && propostaResult.valorMensalidadeDesconto && propostaResult.valorMensalidadeDesconto.toString() != 'R$ 0,00' ? propostaResult.valorMensalidadeDesconto : propostaResult.valorMensalidade.toString()}}-->
<!--                        </span>-->
<!--                        </p>-->
<!--                      </div>-->

<!--                      <div *ngIf="!isCupomValido">-->
<!--                        <p  class="valores-cupom">-->
<!--                          <strong>Mensalidade</strong>-->
<!--                          <span></span>-->
<!--                          <span class="line-through"></span>-->
<!--                          <small></small>-->
<!--                          <span class="valor-final">{{propostaResult.valorMensalidade}}</span>-->
<!--                        </p>-->
<!--                      </div>-->

                      <div>
                        <h4>
                          <strong>Valor do Plano</strong>
                        </h4>
                        <p class="valor-plano">
                        <span class="valor">
                      <small></small>
                          {{propostaResult && propostaResult.valorMensalidadeDesconto && propostaResult.valorMensalidadeDesconto.toString() != 'R$ 0,00' ? propostaResult.valorMensalidadeDesconto : propostaResult.valorMensalidade.toString()}}
                          /
                      <span>mês</span>
                      </span>
                        </p>
                      </div>

                      <div class="btn-mobile">
                        <button type="button" (click)="goToConfirmacao()" class="btn-verde">FINALIZAR CADASTRO</button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </section>

  <div class="aviso">
    <div class="revise-dados">
      <h3>Olá, Pedro!</h3>
      <a href="" class="link-verde">Não sou o Pedro</a>
      <p>Identificamos pelo seu CPF que você já é um cliente Montreal. Para agilizar sua compra, revise os dadoes e
        confirme efetuando seu login.</p>

      <a href="" class="btn-verde">REVISAR E CONCLUIR</a>
      <a href="" class="link-verde">Preciso atualizar meu cadastro</a>
    </div>
  </div>

</div>
